var symphony = symphony || {};

;(function() {

	symphony.advisoryBoardLeadForm = function() {

		$(document).on('click', '.advisoryBoard-leadForm .invalid', function(e) {
			$(this).removeClass('invalid');
		});

		$(document).on('keyup', '.advisoryBoard-leadForm #phone', function(e) {
			$(this).removeClass('invalid');
			var pn = $.trim($(this).val());
			var fp = siteCountry == 'US' ? DN.Validation.formatPhone(pn) : pn;
			if (DN.Validation.isValidPhone(pn) || siteCountry != 'US') {
				$(this).val(fp);
			}
		});
		$(document).on('change', '.advisoryBoard-leadForm #phone', function(e) {
			$(this).removeClass('invalid');
			var pn = $.trim($(this).val());
			if (!DN.Validation.isValidPhone(pn) && siteCountry == 'US') {
				$(this).addClass('invalid');
			}
		});


		$(document).on('keyup', '.advisoryBoard-leadForm #email', function(e) {
			$(this).removeClass('invalid');
		});
		$(document).on('change', '.advisoryBoard-leadForm #email', function(e) {
			$(this).removeClass('invalid');
			var em = $.trim($(this).val());
			if (!DN.Validation.isValidEmail(em)) {
				$(this).addClass('invalid');
			}
		});

		$('form#advisoryBoard-leadForm').submit(function() {
			$(this).find('.required').each(function() {
				$(this).removeClass('invalid');
				if ($.trim($(this).val()) == "") {
					$(this).addClass('invalid');
				}
			});

			if ($(this).find('.invalid').length > 0) {
				return false;
			} else {
				return true;
			}
		});

	};


})();